export const GRD = {
  nav: "nav-generic-report-designer",
  page: "generic-report-designer-page",
  title: "generic-report-designer-title",
  settingsLink: "settings-generic-report-designer-link",
  settingsSection: "settings-generic-report-designer",
  saveBtn: "generic-report-designer-save",
  designTab: "generic-report-designer-design-tab",
  previewTab: "generic-report-designer-preview-tab",
  canvas: "generic-report-designer-canvas",
  firstHeader: "generic-report-designer-first-header",
  subsequentHeader: "generic-report-designer-subsequent-header",
  footer: "generic-report-designer-footer",
  bodyBand: "generic-report-designer-body",
  insertPlaceholder: "generic-report-designer-insert-placeholder",
  insertLogo: "generic-report-designer-insert-logo",
  preview: "generic-report-designer-preview",
  previewFirstPage: "generic-report-designer-preview-first",
  previewSubsequentPage: "generic-report-designer-preview-subsequent",
  version: "generic-report-designer-version",
  status: "generic-report-designer-status",
};
